import { useMutation } from "@tanstack/react-query";
import { Controller, useForm } from "react-hook-form";
import BITextInput from "../../components/BITextInput";
import BIButton from "../../components/BIButton";
import { LogInFormValues, SignupFormValues } from "./authInterface";
import { signupSchema } from "./authDtos";
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from "react-toastify";
import { signup } from "./authQueries";

import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import BIDatePicker from "../../components/BIDatePicker";

const SignupForm = () => {
    const { control, handleSubmit, formState: {errors}, reset, register } = useForm<SignupFormValues>({
		resolver: zodResolver(signupSchema),
	});

    const { mutate:signupMutation, isPending:isLoading } = useMutation({
        mutationKey: ['auth/signup'],
        mutationFn: signup,
    });

    const onSubmit = (formValues: SignupFormValues) => {
        console.log(formValues)
		signupMutation(formValues, {
			onSuccess(data: any) {
				reset(); 
				toast.success('Please check your email for instructions to verify your account.',{autoClose:false});
			},
			onError(error: any) {
                console.log(error?.response?.data?.message)
				if (error?.response?.data?.message) {
					toast.error(error.response.data.message);
				}
                else{
                    toast.error('An error occurred please try again');
                }
			},
		});
	};

    return (
        <div className="w-full flex flex-col items-center">
            <p className="font-bold text-[24px] mb-[20px]">Sign up</p>
            <form onSubmit={handleSubmit(onSubmit)} className="w-full ">
                <BITextInput
                    name="firstName"
                    control={control}
                    type="text"
                    placeholder="Enter your first name"
                    label="First Name"
                />
                <div className="mb-[20px]"/>
                <BITextInput
                    name="lastName"
                    control={control}
                    type="text"
                    placeholder="Enter your last name"
                    label="Last Name"
                />
                <div className="mb-[20px]"/>
                <BITextInput
                    name="email"
                    control={control}
                    type="email"
                    placeholder="Enter your email"
                    label="Email"
                />
                <div className="mb-[20px]"/>
                <div className="flex justify-between">
                    <BIDatePicker
                        showLabel
                        label="Date Of Birth"
                        name="birthdate"
                        control={control}
                        format="y-MM-dd"
                    />
                    
                    <div>
                        <label className="block">Gender</label>
                        <Controller
                            name="gender"
                            control={control}
                            render={({ field }) => (
                            <div className="flex space-x-4">
                                <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    value="M"
                                    checked={field.value === 'M'}
                                    onChange={() => field.onChange('M')}
                                    className="form-radio"
                                />
                                <span className="ml-2">Male</span>
                                </label>
                                <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    value="F"
                                    checked={field.value === 'F'}
                                    onChange={() => field.onChange('F')}
                                    className="form-radio"
                                />
                                <span className="ml-2">Female</span>
                                </label>
                            </div>
                            )}
                            />
                        {errors.gender && <p className="text-red-500">{errors.gender.message}</p>}
                    </div>
        </div>
        
        <div className="mb-[20px]"/>
                <BITextInput
                    name="password"
                    control={control}
                    type="password"
                    placeholder="Enter your Password"
                    label="Password"
                    rules={{ required: "Password is required" }}
                />
                <div className="mb-[20px]"/>
                <BITextInput
                    name="confirmPassword"
                    control={control}
                    type="password"
                    placeholder="Confirm Password"
                    label="Confirm Password"
                    // rules={{ required: "Password is required" }}
                />
                <div className="mt-[40px]"/>
                <BIButton text="Submit" type="submit" isLoading={isLoading}/>
            </form>
        </div>
    );
};

export default SignupForm;
